import { render, staticRenderFns } from "./passwordForgotten.vue?vue&type=template&id=3ee4020e&scoped=true"
import script from "./passwordForgotten.vue?vue&type=script&lang=js"
export * from "./passwordForgotten.vue?vue&type=script&lang=js"
import style0 from "./passwordForgotten.vue?vue&type=style&index=0&id=3ee4020e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4020e",
  null
  
)

export default component.exports